<div style="position:relative;">
	<div *ngFor="let toast of toastQueue | slice:0:2; trackBy:identify; let i = index;" class="md-toast"
		[@EnterLeave]="i ===0 ? 'first' : 'notFirst'" (click)="closeClick(toast, i)">
		<div class="md-toast-content">
			<span class="md-toast-text">{{toast?.data?.message}}</span>
		</div>
	</div>
</div>